import { idKey, NEGATIVE, POSITIVE } from '../model';

/**
 * Interaction matrix as Python source: `A[to][from]` holds the sign of the link from -> to,
 * together with the node ids and labels in matrix order.
 */
export const interactionMatrixText = (nodes, edges) => {
  const indexOf = new Map(nodes.map((node, index) => [idKey(node.id), index]));
  const matrix = Array.from({ length: nodes.length }, () => Array(nodes.length).fill(0));
  edges.forEach((edge) => {
    const toIndex = indexOf.get(idKey(edge.to));
    const fromIndex = indexOf.get(idKey(edge.from));
    if (toIndex === undefined || fromIndex === undefined) return;
    if (edge.sign === POSITIVE) matrix[toIndex][fromIndex] = 1;
    else if (edge.sign === NEGATIVE) matrix[toIndex][fromIndex] = -1;
  });
  const ids = JSON.stringify(nodes.map((node) => node.id));
  const labels = nodes.map((node) => `'${node.label}'`).join(', ');
  return `A = ${JSON.stringify(matrix)}\nids = ${ids}\nlabels = [${labels}]`;
};
